import React from "react";
import { ArrowRight } from "lucide-react";

const SolutionSection = () => {
  return (
    <section className="w-full bg-[white] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12 lg:gap-16 items-center">
          
          {/* LEFT SIDE */}
          <div>
  <h2 className="text-[#2b0902] text-[42px] sm:text-[56px] lg:text-[44px] leading-[0.95] lg:leading-[1.2] font-black tracking-[-3px] font-sans lg:-ml-[40px]">
    Let’s find the right
    <br />
    solution together
  </h2>
</div>

          {/* RIGHT SIDE CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
            
            {/* CARD 1 */}
<div className="bg-[#efe2d7] rounded-[12px] px-8 py-10 h-auto lg:h-[300px] lg:w-[370px] flex flex-col">
  
  <h3 className="font-serif text-[32px] lg:text-[22px] leading-[1.08] lg:leading-[1.4] text-[#1d0600] mb-8">
    Can’t find the integration you’re looking for?
  </h3>

  <p className="text-[18px] lg:text-[15px] lg:leading-[1.4] leading-[1.7] text-[#111] max-w-[420px]">
    If your system is bespoke or you still need help, connect with
    our team to explore solutions.
  </p>

  <button className="mt-aut lg:mt-[10px]  w-[46px] h-[46px] rounded-full bg-[#ff5a00] flex items-center justify-center hover:scale-105 transition">
    <ArrowRight className="text-white w-7 h-7 lg:w-5 lg:h-5" />
  </button>
</div>

{/* CARD 2 */}
<div className="bg-[#efe2d7] rounded-[12px] px-8 py-10 h-auto lg:h-[300px] lg:w-[370px] flex flex-col">
  
  <h3 className="font-serif text-[32px] lg:text-[22px] leading-[1.08] lg:leading-[1.4] text-[#1d0600] mb-8">
    Interested in partnering with DailyPay?
  </h3>

  <p className="text-[18px] lg:text-[15px] lg:leading-[1.4] leading-[1.7] text-[#111] max-w-[420px]">
    Learn more about how we partner with HCM, workforce
    management, and bank & financial institutions.
  </p>

  <button className="mt-auto lg:mt-[10px] w-[46px] h-[46px] rounded-full bg-[#ff5a00] flex items-center justify-center hover:scale-105 transition">
    <ArrowRight className="text-white w-7 h-7 lg:w-5 lg:h-5" />
  </button>
</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;